import React, {useEffect} from 'react'
import './Pr_Apice.css'
import {NavLink} from 'react-router-dom'
import Intro_Image from "./Img/Intro-image.png"

const Pr_Apice = () => {
    
    useEffect(() => {
        let title = document.getElementsByTagName('title')[0]
        title.innerHTML = "Progetto 4C | Apice"
        window.scrollTo(0,0)
    }, [])

    const Primo_Pogetto =()=>{
        window.open(
            'https://www.canva.com/design/DAFimIILuiA/i-_yKBqasMVEyWLOrE1w0A/view?website#2:l-unione-europea',
            '_blank'
        )
    }

    const Secondo_Pogetto =()=>{
        window.open(
            'https://www.canva.com/design/DAFizwwvdKs/Ilppe3w5mezkAsleTLUWJA/view?website#2:aderire-all-unione-europea',
            '_blank'
        )
    }

    const Terzo_Pogetto =()=>{
        window.open(
            'https://www.canva.com/design/DAFjKfGuBu4/JIiAmsJyxden_CuC2x4m3w/view?website#2',
            '_blank'
        )
    }

    const Quarto_Pogetto =()=>{
        window.open(
            'https://progetto-apice.web.app/',
            '_blank'
        )
    }

    const Quinto_Pogetto =()=>{
        window.open(
            'https://www.canva.com/design/DAFi-EznNGE/z3HDAjie3ZiI0uzyGniIwg/view?website#2:fonti-sito-nato-https-www.nato.int-nato-welcome-index_it.html-conoscenze-personali',
            '_blank'
        )
    }

  return (
    <div>
         {/* === sotto nav bar === */}

         <div className='row under-nav d-flex justify-content-center align-items-center mt-5'>
            <div className="col-xl-4 col-lg-4 col-md-7 col-sm-10 col-11 d-flex justify-content-center align-items-center order-lg-1 order-xl-1 order-2 pt-lg-0 pt-xl-0 pt-4" data-aos="fade-up" data-aos-delay="400">
                <div>
                    <h1 className='sub-under-nav'>| Progetti Apice<br/> Benvenuto nei progetti della 4C di APICE</h1>
                    <p className='txt-under-nav mt-3'>
                        In questa pagina troverai tutti i lavori fatti da questi studenti di questa classe!
                    </p>

                    <div className='d-flex justify-content-lg-start justify-content-xl-start justify-content-md-center justify-content-sm-center justify-content-center mb-3'>
                        <NavLink className='btn-esplora col-6' style={{textDecoration:"none", color:"white"}} to={"/Progetti"}> <strong>Torna ai Progetti</strong> </NavLink>
                    </div>
                </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-9 col-10 mt-5 d-flex justify-content-center order-1 order-lg-2 order-xl-2 mt-5" data-aos="zoom-in" data-aos-delay="400">
                <img src={Intro_Image} alt="" className='img-fluid flaoting res-intro-image'/>
            </div>
        </div>

        <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 310" xmlns="http://www.w3.org/2000/svg" className="mw transition duration-300 ease-in-out delay-150">
            <path d="M 0,400 C 0,400 0,200 0,200 C 198.13333333333333,154.66666666666669 396.26666666666665,109.33333333333334 529,128 C 661.7333333333333,146.66666666666666 729.0666666666667,229.33333333333331 870,252 C 1010.9333333333333,274.6666666666667 1225.4666666666667,237.33333333333334 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" strokeWidth="0" fill="#0104a3" fillOpacity="1" className="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 200)"></path>
        </svg>
        
        {/* === sotto nav bar === */}

        

        <div className='row justify-content-center cont-prog'>

            <h2 className='tit col-12 d-flex justify-content-center tx-al mb-5 mt-4'>Progetti Relativi</h2>
            
            <article className="article-wrapper col-xl-5 col-lg-5 col-md-11 col-sm-10 col-9 mr-xl-5 mr-lg-5 mr-0 mb-5" onClick={Primo_Pogetto}>
                <div className="rounded-lg container-project" ></div>

                <div className="project-info">
                    <div className="flex-pr">
                    <div className="project-title text-nowrap">1° Gruppo - Audisio, Massimo, Galeasso, Paseri</div>
                    <div className="project-hover">
                        <svg
                        style={{ color: 'black' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="2em"
                        height="2em"
                        color="black"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        stroke="currentColor"
                        >
                        <line y2="12" x2="19" y1="12" x1="5" />
                        <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </div>
                    </div>
                    <div className="types">
                    <span
                        style={{
                        backgroundColor: 'rgba(165, 96, 247, 0.43)',
                        color: 'rgb(85, 27, 177)'
                        }}
                        className="project-type"
                    >
                        • Canva
                    </span>
                    <span className="project-type">• Apice</span>
                    </div>
                </div>
            </article>


            <article className="article-wrapper col-xl-5 col-lg-5 col-md-11 col-sm-10 col-9 mr-xl-5 mr-lg-5 mr-0 mb-5" onClick={Secondo_Pogetto}>
                <div className="rounded-lg container-project" ></div>

                <div className="project-info">
                    <div className="flex-pr">
                    <div className="project-title text-nowrap">2° Gruppo - Martini, De Boni, Zhou, Galfrè</div>
                    <div className="project-hover">
                        <svg
                        style={{ color: 'black' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="2em"
                        height="2em"
                        color="black"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        stroke="currentColor"
                        >
                        <line y2="12" x2="19" y1="12" x1="5" />
                        <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </div>
                    </div>
                    <div className="types">
                    <span
                        style={{
                        backgroundColor: 'rgba(165, 96, 247, 0.43)',
                        color: 'rgb(85, 27, 177)'
                        }}
                        className="project-type"
                    >
                        • Canva
                    </span>
                    <span className="project-type">• Apice</span>
                    </div>
                </div>
            </article>

            <article className="article-wrapper col-xl-5 col-lg-5 col-md-11 col-sm-10 col-9 mr-xl-5 mr-lg-5 mr-0 mb-5" onClick={Terzo_Pogetto}>
                <div className="rounded-lg container-project" ></div>

                <div className="project-info">
                    <div className="flex-pr">
                    <div className="project-title text-nowrap">3° Gruppo - Bracco, Minetti, Barra, Dossetto</div>
                    <div className="project-hover">
                        <svg
                        style={{ color: 'black' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="2em"
                        height="2em"
                        color="black"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        stroke="currentColor"
                        >
                        <line y2="12" x2="19" y1="12" x1="5" />
                        <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </div>
                    </div>
                    <div className="types">
                    <span
                        style={{
                        backgroundColor: 'rgba(165, 96, 247, 0.43)',
                        color: 'rgb(85, 27, 177)'
                        }}
                        className="project-type"
                    >
                        • Canva
                    </span>
                    <span className="project-type">• Apice</span>
                    </div>
                </div>
            </article>

            <article className="article-wrapper col-xl-5 col-lg-5 col-md-11 col-sm-10 col-9 mr-xl-5 mr-lg-5 mr-0 mb-5" onClick={Quarto_Pogetto}>
                <div className="rounded-lg container-project" ></div>

                <div className="project-info">
                    <div className="flex-pr">
                    <div className="project-title text-nowrap">4° Gruppo - Alba, Culasso, Di Marco, Vaschetto</div>
                    <div className="project-hover">
                        <svg
                        style={{ color: 'black' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="2em"
                        height="2em"
                        color="black"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        stroke="currentColor"
                        >
                        <line y2="12" x2="19" y1="12" x1="5" />
                        <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </div>
                    </div>
                    <div className="types">
                    <span
                        style={{
                        backgroundColor: 'rgba(165, 96, 247, 0.43)',
                        color: 'rgb(85, 27, 177)'
                        }}
                        className="project-type"
                    >
                        • Sito
                    </span>
                    <span className="project-type">• Apice</span>
                    </div>
                </div>
            </article>

            <article className="article-wrapper col-xl-5 col-lg-5 col-md-11 col-sm-10 col-9 mr-xl-5 mr-lg-5 mr-0 mb-5" onClick={Quinto_Pogetto}>
                <div className="rounded-lg container-project" ></div>

                <div className="project-info">
                    <div className="flex-pr">
                    <div className="project-title text-nowrap">5° Gruppo - Fortunato, Soave, Rolle, Volpe</div>
                    <div className="project-hover">
                        <svg
                        style={{ color: 'black' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="2em"
                        height="2em"
                        color="black"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        fill="none"
                        stroke="currentColor"
                        >
                        <line y2="12" x2="19" y1="12" x1="5" />
                        <polyline points="12 5 19 12 12 19" />
                        </svg>
                    </div>
                    </div>
                    <div className="types">
                    <span
                        style={{
                        backgroundColor: 'rgba(165, 96, 247, 0.43)',
                        color: 'rgb(85, 27, 177)'
                        }}
                        className="project-type"
                    >
                        • Canva
                    </span>
                    <span className="project-type">• Apice</span>
                    </div>
                </div>
            </article>

        </div>

    </div>
  )
}

export default Pr_Apice